import { render, staticRenderFns } from "./SavingRuleModal.vue?vue&type=template&id=300a9359&"
import script from "./SavingRuleModal.vue?vue&type=script&lang=ts&"
export * from "./SavingRuleModal.vue?vue&type=script&lang=ts&"
import style0 from "./SavingRuleModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports